import ProductPageLayout from "@/components/ProductPageLayout";
import lamelliverho from "@/assets/lamelliverho.png?format=webp&w=800";

const LamelliverhoAsennus = () => (
  <ProductPageLayout title="Lamelliverho asennus" metaDescription="Lamelliverhojen asennus Keski-Uudellamaalla. Pystylamelli suuriin ikkunoihin ja liukuoviin." image={lamelliverho} partner="osio" path="/lamelliverho-asennus" alternatePath="/en/vertical-blind-installation">
    <p className="text-muted-foreground leading-relaxed">
      Lamelliverhot eli pystylamellit ovat erinomainen valinta suuriin ikkunoihin, liukuoviin ja toimistotiloihin. 
      Lamellien kääntökulman avulla voit säätää valon määrää portaattomasti.
    </p>
    <h2 className="font-display text-2xl font-bold mt-8 mb-3">Lamelliverhon käyttökohteet</h2>
    <ul className="space-y-2 text-muted-foreground">
      <li>✓ Suuret panoraamaikkunat</li>
      <li>✓ Liukuovet ja parvekeikkunat</li>
      <li>✓ Toimistotilat ja neuvotteluhuoneet</li>
      <li>✓ Tilanjako ja huonekaluratkaisut</li>
    </ul>
    <p className="text-muted-foreground mt-6 leading-relaxed">
      Palvelemme Hyvinkäällä, Järvenpäässä, Keravalla, Mäntsälässä, Nurmijärvellä, Pornaisissa ja Tuusulassa. 
      Tutustu <a href="https://osio.fi" target="_blank" rel="noopener noreferrer" className="underline underline-offset-2 text-foreground">Osion lamelliverhoihin</a>.
    </p>
  </ProductPageLayout>
);

export default LamelliverhoAsennus;
